/**
 * Dashboard Components
 * A layout component that provides the main application structure
 * Includes navigation, content area, and notification system
 */

import { Outlet } from "react-router-dom";
import Navbar from "./navbar";
import NotificationsContainer from "../notification-component/notifications-container";

/**
 * Dashboard Component
 * Main layout wrapper component that structures the admin interface
 *
 * Features:
 * - Persistent navigation bar
 * - Dynamic content rendering via React Router's Outlet
 * - Global notification system
 * - Consistent styling and theme application
 *
 * The component maintains a consistent layout while allowing dynamic content
 * to be rendered through nested routes.
 *
 * @returns {JSX.Element} A structured dashboard layout with navigation and notifications
 */
const Dashboard = () => {
  return (
    <div className="bg-primary border-primary">
      <Navbar />
      <Outlet />
      <NotificationsContainer />
    </div>
  );
};

export default Dashboard;
